define("shared/components/shared/wizards/credentials/ig-business-setup", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/errors/index", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _utils, _component2, _tracking, _emberConcurrency, _index, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/errors/index",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div ...attributes>
    {{#if this.showCredentialsStatus}}
      <Shared::Credentials::Status
        @beginRefresh={{this.beginRefresh}}
        @close={{@close}}
        @completed={{this.completed}}
        @resetState={{this.resetState}}
        @revokePermissions={{task this.revokePermissions}}
        @source={{@source}}
      />
    {{else if this.showConnection}}
      <Shared::Credentials::Connection
        @close={{@close}}
        @connectedPage={{this.connectedPage}}
        @facebookUser={{this.facebookUser}}
        @pages={{this.pages}}
        @refreshBusiness={{task this.refreshBusiness}}
        @selectPage={{this.selectPage}}
        @selectPageNotFound={{this.selectPageNotFound}}
      />
    {{else if this.showUnconnectedPages}}
      <Shared::Credentials::UnconnectedPages
        @checkScope={{this.checkScope}}
        @close={{@close}}
        @connectedPage={{this.connectedPage}}
        @facebookUser={{this.facebookUser}}
        @pages={{this.pages}}
        @selectPage={{this.selectPage}}
        @selectPageNotFound={{this.selectPageNotFound}}
        @showHelpDropdown={{false}}
      />
    {{else if this.showFindNewPage}}
      <Shared::Credentials::FindNewPage
        @close={{@close}}
        @facebookUser={{this.facebookUser}}
        @revokePermissions={{task this.revokePermissions}}
      />
    {{else if this.showGrantNewPermissions}}
      <Shared::Credentials::GrantNewPermissions @close={{@close}} @refreshBusiness={{task this.refreshBusiness}} />
    {{else if this.showDocsForNewPage}}
      <Shared::Credentials::DocsForNewPage
        @close={{@close}}
        @instagramSettingsLink={{this.instagramSettingsLink}}
        @revokePermissions={{task this.revokePermissions}}
      />
    {{else if this.showMissingPermissions}}
      <Shared::Credentials::MissingPermissions
        @close={{@close}}
        @facebookUser={{this.facebookUser}}
        @missingScopes={{this.missingScopes}}
        @revokePermissions={{task this.revokePermissions}}
      />
    {{else if this.showConnectionFailure}}
      <Shared::Credentials::ConnectionFailure
        @close={{@close}}
        @dismissContactUs={{this.dismissContactUs}}
        @source={{@source}}
      />
    {{/if}}
  </div>
  */
  {
    "id": "VIf53OiG",
    "block": "[[[11,0],[17,1],[12],[1,\"\\n\"],[41,[30,0,[\"showCredentialsStatus\"]],[[[1,\"    \"],[8,[39,1],null,[[\"@beginRefresh\",\"@close\",\"@completed\",\"@resetState\",\"@revokePermissions\",\"@source\"],[[30,0,[\"beginRefresh\"]],[30,2],[30,0,[\"completed\"]],[30,0,[\"resetState\"]],[28,[37,2],[[30,0,[\"revokePermissions\"]]],null],[30,3]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showConnection\"]],[[[1,\"    \"],[8,[39,3],null,[[\"@close\",\"@connectedPage\",\"@facebookUser\",\"@pages\",\"@refreshBusiness\",\"@selectPage\",\"@selectPageNotFound\"],[[30,2],[30,0,[\"connectedPage\"]],[30,0,[\"facebookUser\"]],[30,0,[\"pages\"]],[28,[37,2],[[30,0,[\"refreshBusiness\"]]],null],[30,0,[\"selectPage\"]],[30,0,[\"selectPageNotFound\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showUnconnectedPages\"]],[[[1,\"    \"],[8,[39,4],null,[[\"@checkScope\",\"@close\",\"@connectedPage\",\"@facebookUser\",\"@pages\",\"@selectPage\",\"@selectPageNotFound\",\"@showHelpDropdown\"],[[30,0,[\"checkScope\"]],[30,2],[30,0,[\"connectedPage\"]],[30,0,[\"facebookUser\"]],[30,0,[\"pages\"]],[30,0,[\"selectPage\"]],[30,0,[\"selectPageNotFound\"]],false]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showFindNewPage\"]],[[[1,\"    \"],[8,[39,5],null,[[\"@close\",\"@facebookUser\",\"@revokePermissions\"],[[30,2],[30,0,[\"facebookUser\"]],[28,[37,2],[[30,0,[\"revokePermissions\"]]],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showGrantNewPermissions\"]],[[[1,\"    \"],[8,[39,6],null,[[\"@close\",\"@refreshBusiness\"],[[30,2],[28,[37,2],[[30,0,[\"refreshBusiness\"]]],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showDocsForNewPage\"]],[[[1,\"    \"],[8,[39,7],null,[[\"@close\",\"@instagramSettingsLink\",\"@revokePermissions\"],[[30,2],[30,0,[\"instagramSettingsLink\"]],[28,[37,2],[[30,0,[\"revokePermissions\"]]],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showMissingPermissions\"]],[[[1,\"    \"],[8,[39,8],null,[[\"@close\",\"@facebookUser\",\"@missingScopes\",\"@revokePermissions\"],[[30,2],[30,0,[\"facebookUser\"]],[30,0,[\"missingScopes\"]],[28,[37,2],[[30,0,[\"revokePermissions\"]]],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showConnectionFailure\"]],[[[1,\"    \"],[8,[39,9],null,[[\"@close\",\"@dismissContactUs\",\"@source\"],[[30,2],[30,0,[\"dismissContactUs\"]],[30,3]]],null],[1,\"\\n  \"]],[]],null]],[]]]],[]]]],[]]]],[]]]],[]]]],[]]]],[]]],[13]],[\"&attrs\",\"@close\",\"@source\"],false,[\"if\",\"shared/credentials/status\",\"task\",\"shared/credentials/connection\",\"shared/credentials/unconnected-pages\",\"shared/credentials/find-new-page\",\"shared/credentials/grant-new-permissions\",\"shared/credentials/docs-for-new-page\",\"shared/credentials/missing-permissions\",\"shared/credentials/connection-failure\"]]",
    "moduleName": "shared/components/shared/wizards/credentials/ig-business-setup.hbs",
    "isStrictMode": false
  });
  let IgBusinessSetupComponent = _exports.default = (_dec = (0, _service.inject)('social/facebook-graph'), _dec2 = (0, _service.inject)('social/facebook-auth'), _dec3 = (0, _service.inject)('social/instagram-business'), _dec4 = (0, _object.computed)('isDisconnected', 'isExpiring'), _dec5 = (0, _object.computed)('activePageEqualsGivenPage', 'nameOfPage', 'activePageId'), (_class = class IgBusinessSetupComponent extends _component2.default {
    get missingPage() {
      return this.activePageId === 0;
    }
    get state() {
      return this.credentials.state;
    }
    get showConnection() {
      return this.state.currentModal === 'currentConnection';
    }
    get showConnectionFailure() {
      return this.state.currentModal === 'connectionFailure';
    }
    get showCredentialsStatus() {
      return this.state.currentModal === 'credentialsStatus';
    }
    get showDocsForNewPage() {
      return this.state.currentModal === 'docsForNewPage';
    }
    get showFindNewPage() {
      return this.state.currentModal === 'findNewPage';
    }
    get showGrantNewPermissions() {
      return this.state.currentModal === 'grantNewPermissions';
    }
    get showUnconnectedPages() {
      return this.state.currentModal === 'unconnectedPages';
    }
    get showMissingPermissions() {
      return this.state.currentModal === 'missingPermissions';
    }
    get activePageName() {
      return this.state.activePage?.name;
    }
    get activePageEqualsGivenPage() {
      return this.activePageName === 'nameOfPage';
    }
    get activePageId() {
      return this.state.activePage?.id;
    }
    get businessAccountId() {
      return this.socialProfile.get('businessAccountId');
    }
    get hasUnconnectedProfessional() {
      return this.socialProfile.get('hasUnconnectedProfessional');
    }
    get connectedPageId() {
      return this.socialProfile.get('facebookPageId');
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
    get isDisconnected() {
      return this.socialProfile.get('needsProfessionalTokenRefresh');
    }
    get isExpiring() {
      return this.socialProfile.get('instagramBusinessTokenExpiring');
    }
    get nameOfPage() {
      return this.state.nameOfPage;
    }
    get nickname() {
      return this.socialProfile.get('nickname');
    }
    get owner() {
      return this.auth.currentAccount.get('owner');
    }
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "credentials", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "facebookGraph", _descriptor4, this);
      _initializerDefineProperty(this, "facebookAuth", _descriptor5, this);
      _initializerDefineProperty(this, "instagramBusiness", _descriptor6, this);
      _initializerDefineProperty(this, "segment", _descriptor7, this);
      _initializerDefineProperty(this, "completed", _descriptor8, this);
      _initializerDefineProperty(this, "connectedPages", _descriptor9, this);
      _initializerDefineProperty(this, "pages", _descriptor10, this);
      _initializerDefineProperty(this, "authResponse", _descriptor11, this);
      _initializerDefineProperty(this, "facebookUser", _descriptor12, this);
      _defineProperty(this, "refreshBusiness", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (allowRevoke) {
          try {
            yield this.facebookAuth.authenticateFacebook(this.instagramBusiness.potentialScopes);
            const response = yield this.instagramBusiness.refreshBusiness.perform(this.args.socialProfile);
            const allScopes = yield this.checkAllScopes.perform();
            // eslint-disable-next-line no-unused-vars
            const isMissingScopes = Object.entries(allScopes).some(_ref => {
              let [_scope, isValid] = _ref;
              return !isValid;
            });
            if (isMissingScopes) {
              throw new _index.CredentialsMissingPermissionsError().withAdditionalData({
                allScopes
              });
            }
            if (response) {
              this.credentials.updateCurrentModal('credentialsStatus');
              this.segment.track('connected-successfully-creds-wiz', {
                social_profile: this.args.socialProfile,
                page: this.credentials.source
              });
              this.completed = true;
              return this.completed;
            }
          } catch (error) {
            if (error instanceof _index.CredentialsMissingPermissionsError) {
              const {
                allScopes
              } = error.additionalData ? error.additionalData.shift() : {
                allScopes: null
              };
              return error.resolve.call(this, allScopes);
            }
            this.errors.log(error);
            if (!allowRevoke) {
              this.auth.setSocialProfile(this.args.socialProfile);
              this.credentials.updateCurrentModal('connectionFailure');
            } else {
              this.credentials.updateHasRevoked(true);
              this.credentials.updateCurrentModal('missingPermissions');
            }
          }
        }
      }), null, "refreshBusiness", null));
      _defineProperty(this, "checkAllScopes", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const response = yield this.args.socialProfile.facebookTokenDebug({
            token: this.args.socialProfile.businessAccountToken
          });
          const {
            granular_scopes
          } = response;
          const checkScope = (scope, id) => {
            const scopeValue = granular_scopes.find(item => item.scope === scope);
            return scopeValue && (!scopeValue.target_ids || scopeValue.target_ids.includes(id));
          };
          const instagram_basic = checkScope('instagram_basic', this.businessAccountId);
          const instagram_content_publish = checkScope('instagram_content_publish', this.businessAccountId);

          // use the actual connected page id by default
          const pageId = this.connectedPageId || this.activePageId;
          let page;
          try {
            page = yield this.facebookGraph.fetchPage.perform(this.args.socialProfile.businessAccountToken, pageId);
          } catch (error) {
            this.errors.log(error, {}, 'info');
          }
          let business_management = true;
          if (page?.business) {
            business_management = checkScope('business_management', page.business.id);
          }
          const pages_read_user_content = checkScope('pages_read_user_content', pageId);
          const pages_manage_posts = checkScope('pages_manage_posts', pageId);
          const result = {
            business_management,
            instagram_basic,
            instagram_content_publish,
            pages_read_user_content,
            pages_manage_posts
          };
          console.log(result);
          return result;
        }
      }), null, "checkAllScopes", null));
      _defineProperty(this, "revokePermissions", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            yield this.instagramBusiness.revokePermissions.perform(this.args.socialProfile);
            const eventName = this.missingPage ? 'revoked-and-reauth-missing-page-creds-wiz' : 'revoked-and-reauth-missing-permissions-creds-wiz';
            this.segment.track(eventName, {
              social_profile: this.args.socialProfile,
              page: this.args.source
            });
          } catch (error) {
            this.errors.log(error);
          } finally {
            this.credentials.updateCurrentModal('grantNewPermissions');
          }
        }
      }), null, "revokePermissions", null));
      this.credentials.initState(this.args.socialProfile, this.args.source);
    }
    get featureStatusCss() {
      if (this.isDisconnected) {
        return 'u--m__r__xs i-warning u--text--danger';
      } else if (this.isExpiring) {
        return 'u--m__r__xs i-danger-1 u--text--warning';
      }
      return 'u--m__r__xs i-verified u--text--success';
    }
    get instagramSettingsLink() {
      if (this.activePageId) {
        return `https://www.facebook.com/${this.nameOfPage}-${this.activePageId}/settings/?tab=instagram_management&ref=page_edit`;
      }
      return null;
    }
    dismissContactUs() {
      this.args.close();
      this.segment.track('canceled-contact-us-creds-wiz', {
        social_profile: this.args.socialProfile,
        page_name: this.args.source
      });
    }
    resetState() {
      this.credentials.updateActivePage(null);
      this.credentials.updateIsAdminOfPage(null);
      this.credentials.updateIsCorrectPage(null);
      this.credentials.updateNameOfPage(null);
      this.credentials.updateCurrentModal('credentialsStatus');
    }

    /**
     * Take the response of the instagram business `getConnectedPages` call and setup the next step in the wizard
     *
     * @method beginRefresh
     * @param {Object} Response
     *
     */
    beginRefresh(args) {
      const {
        connectedPages,
        pages,
        authResponse,
        facebookUser
      } = args;
      const sortedPages = pages ? pages.sort((a, b) => a.name.localeCompare(b.name)) : [];
      this.connectedPages = connectedPages;
      this.pages = sortedPages;
      this.authResponse = authResponse;
      this.facebookUser = facebookUser;
      if (connectedPages && connectedPages.length) {
        this.credentials.updateCurrentModal('currentConnection');
        const connectedPage = connectedPages.firstObject;
        this._selectPage(connectedPage);
        this.connectedPage = _object.default.create(connectedPage);
        if (connectedPages.length > 1) {
          this.errors.log('Graph API is returning more than 1 connected page', args, 'critical');
          this.segment.track('more-than-one-connected-page-creds-wiz', {
            social_profile: this.args.socialProfile,
            connected_pages: JSON.stringify(connectedPages),
            page: this.credentials.source
          });
        }
      } else {
        this.credentials.updateCurrentModal('unconnectedPages');
      }
    }
    selectPage(page) {
      if ((0, _utils.isEqual)(this.activePageId, page.id)) {
        this._selectPage(null);
      } else {
        this._selectPage(page);
      }
    }
    selectPageNotFound() {
      this.credentials.updateNameOfPage(null);
      if (this.missingPage) {
        this.credentials.updateActivePage(null);
      } else {
        this.credentials.updateActivePage({
          id: 0,
          name: null
        });
      }
    }
    _selectPage(page) {
      this.credentials.updateActivePage(page);
      if (page && page.name) {
        this.credentials.updateNameOfPage(page.name);
      } else {
        this.credentials.updateNameOfPage(null);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "credentials", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "facebookGraph", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "facebookAuth", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "completed", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "connectedPages", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "pages", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "authResponse", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "facebookUser", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "featureStatusCss", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "featureStatusCss"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "instagramSettingsLink", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "instagramSettingsLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dismissContactUs", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "dismissContactUs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetState", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "beginRefresh", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "beginRefresh"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectPage", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectPageNotFound", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectPageNotFound"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, IgBusinessSetupComponent);
});